import { render, staticRenderFns } from "./BryntumResourceFilter.vue?vue&type=template&id=32f6fdc7"
import script from "./BryntumResourceFilter.vue?vue&type=script&lang=js"
export * from "./BryntumResourceFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports